export { parseTime, formatTime } from '@/utils'

export function dictFilter(val, opts) {
  let obj = opts.find(item => item.value == val) || {}
  return obj.label || '-'
}

export function dictRelationFilter(val, opts) {
  let obj = opts.find(item => item.valueRelation.includes(val)) || {}
  return obj.label || '-'
}

export function moneyTothod(value){
  try {
    if (!value && value !== 0) return "-";
    let value2Array = value.toString().split(".");
    let intPart = value2Array[0] || '0'; //获取整数部分
    let intPartFormat = intPart
      .toString()
      .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); //将整数部分逢三一断
    let floatPart = ".00"; //预定义小数部分
    //=2表示数据有小数位
    if (value2Array.length == 2) {
      floatPart = value2Array[1].toString(); //拿到小数部分
      if (floatPart.length == 1) {
        //补0,实际上用不着
        return intPartFormat + "." + floatPart + "0";
      } else {
        return intPartFormat + "." + floatPart;
      }
    } else {
      return intPartFormat + floatPart;
    }
  } catch (e) {
    return "-";
  }
}

export function timeFilter(time) {
  if(!time) return '';
  let date = new Date(time),
      year = date.getFullYear(),
      month = date.getMonth(),
      day = date.getDate();
  return `${['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][month]} ${day}, ${year}`
}

export function numFilter(num) {
  if(!num) return '0.00'
  let numArr = num.toString().split('.')
  return numArr[0] + '.' + (!numArr[1] ? '00' : ('' + numArr[1]).padEnd(2, '0'))
}
